import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateFormatService } from 'src/app/shared/services/date-format.service';

@Component({
  selector: 'app-more-date-picker',
  templateUrl: './more-date-picker-modal.component.html',
  standalone: false
})
export class MoreDatePickerComponent {
  @Input() disabled = true; // Disable the date picker if needed
  @Output() readonly postDateChange = new EventEmitter<Date>();
  @Output() readonly taxDateChange = new EventEmitter<Date>();

  visible = false;
  taxDatePicker = false;
  taxDate: Date = new Date();
  postDatePicker = false;
  postDate: Date = new Date();
  documentDate: Date = new Date();

  constructor(
    public dateFormatService: DateFormatService,
  private cdr: ChangeDetectorRef
  ) {}

  show(docDate?: Date | null, postDate?: Date | null, taxDate?: Date | null): void {
    this.visible = true;

    if (docDate) {
      this.documentDate = docDate;
    }
    if (postDate) {
      this.postDatePicker = true;
      this.postDate = postDate;
    }
    if (taxDate) {
      this.taxDatePicker = true;
      this.taxDate = taxDate;
    }

    console.log('show more date picker', {
      documentDate: this.documentDate,
      postDate: this.postDate,
      taxDate: this.taxDate,
      postDatePicker: this.postDatePicker,
      taxDatePicker: this.taxDatePicker
    });

  this.cdr.detectChanges(); // Force change detection
  }

  onOk(): void {
    // Emit the selected dates back to the parent component
    if (this.postDatePicker) {
      this.postDateChange.emit(this.postDate);
    }
    if (this.taxDatePicker) {
      this.taxDateChange.emit(this.taxDate);
    }
    this.visible = false;
    this.taxDatePicker = false;
    this.postDatePicker = false;
  }

  disabledDate = (current: Date): boolean => {
    // Make sure documentDate is a proper Date object
    const docDate =
      this.documentDate instanceof Date
        ? this.documentDate
        : new Date(this.documentDate);

    // Compare dates based only on year, month, and day (ignoring time)
    const currentDate = new Date(current.getFullYear(), current.getMonth(), current.getDate());
    const documentDate = new Date(docDate.getFullYear(), docDate.getMonth(), docDate.getDate());
    
    // Disable dates before documentDate, allow selecting documentDate and any date after
    return currentDate < documentDate;
  };
}
